var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    _vm.show
      ? _c("div", { staticClass: "toast", class: "toast-" + _vm.type }, [
          _c("div", { staticClass: "toast-icon" }, [
            _vm.type == "success"
              ? _c("div", { staticClass: "icon-circle icon-success" }, [
                  _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                    _c("path", {
                      attrs: {
                        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z",
                        fill: "white",
                      },
                    }),
                  ]),
                ])
              : _c("div", { staticClass: "icon-circle icon-error" }, [
                  _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                    _c("path", {
                      attrs: {
                        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z",
                        fill: "white",
                      },
                    }),
                  ]),
                ]),
          ]),
          _c("div", { staticClass: "toast-content" }, [
            _c("div", { staticClass: "toast-message" }, [
              _vm._v(_vm._s(_vm.message)),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }